import { HttpClient } from '@angular/common/http';
import { Template } from '@angular/compiler/src/render3/r3_ast';
import { Injectable } from '@angular/core';
import { stringToKeyValue } from '@angular/flex-layout/extended/typings/style/style-transforms';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
import { MessagerComponent } from '../messager/messager/messager.component';
import { Questions, Templates } from './mfmodels';



enum TYPES {

  input = 1,
  checkbox = 2,
  number = 3,
  dropdown = 4,
  textbox = 5
}

@Injectable({
  providedIn: 'root'
})
export class MultiFamilyService {

  private baseURL = environment.baseUrl;
  private questionSubject = new BehaviorSubject<Questions[]>([]); //subject for initial locations
  private templateSubject = new BehaviorSubject<any[]>([]); //subject for initial locations

  questions$: Observable<Questions[]> = this.questionSubject.asObservable(); //observable for questions
  template$: Observable<Templates[]> = this.templateSubject.asObservable(); //observable for templates


  constructor(private http: HttpClient,
    private messager: MessagerComponent,
    private auth: AuthService) {

    }

  fetchQuestions = () => this.http.get<Questions[]>(this.baseURL + '/rhAPI/multifamly/questions', {observe: 'body'}).subscribe(
    res => { console.log(res); this.questionSubject.next(res)}, err=>{console.log(err)}
  )

  fetchTemplates = () => this.http.get<Templates[]>(this.baseURL + '/rhAPI/multifamly/templates', {observe: 'body'}).subscribe(
    res => {this.templateSubject.next(res)}
  )


  createTemplate(newTemplate: { name: string; fields: any; numfields: number;  description?: string }): void{
    this.http.post<any>(this.baseURL + '/rhAPI/multifamly/newTemplate', newTemplate, {observe: 'body'}).subscribe(
      res => {
        console.log(newTemplate);
        console.log(res);
        this.fetchTemplates();
        if(res.Error){
          this.messager.openSnackBar('Error creating template. ' + res.Message,'', 'errorAlert');
        } else {
          this.messager.openSnackBar('Successfully created ' + newTemplate.name,'', 'successAlert');
        }
      },err => {
        this.messager.openSnackBar('Error creating template.','', 'errorAlert');
      }
    );
  }

  createQuestion(newItem: { descr: string; inpt: any; choices?; }): void {
    this.http.post(this.baseURL + '/rhAPI/multifamly/newQuestion', newItem, {observe: 'body'}).subscribe(
      res => {
        this.fetchQuestions();
        this.messager.openSnackBar('Question added.', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Error creating question. .','', 'errorAlert');
      }
    );
  }

  deleteQuestion(question): void {
    this.http.post(this.baseURL + '/rhAPI/multifamly/deleteQuestion/' + question.id,{},{observe: 'body'}).subscribe(
      res => {
        this.fetchQuestions();
        this.messager.openSnackBar('Question deleted.', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Error deleting question. .','', 'errorAlert');
      }
    );
  }

  updateQuestion(newItem: { id: number; descr: string; inpt: any; choices?; }): void {
    console.log(newItem);
    this.http.post(this.baseURL + '/rhAPI/multifamly/updateQuestion', newItem, {observe: 'body'}).subscribe(
      res => {
        this.fetchQuestions();
        this.messager.openSnackBar('Question updated.', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Error updating question. .','', 'errorAlert');
      }
    );
  }

  getSingleTemplate(id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/multifamly/templates/'+ id, {observe: 'body'});
  }

  updateTemplate(newTemplate: { id: number; name: string; fields: any; numfields: number;  description?: string }): void{
    this.http.post<any>(this.baseURL + '/rhAPI/multifamly/updateTemplate/' + newTemplate.id, newTemplate, {observe: 'body'}).subscribe(
      res => {
        if(res.Error){
          this.messager.openSnackBar('Error updating template: ' + res.Message, '', 'errorAlert');
        }
          this.fetchTemplates();
          this.messager.openSnackBar('Successfully created ' + newTemplate.name,'', 'successAlert');
      },err => {
        this.messager.openSnackBar('Error updating template.','', 'errorAlert');
      }
    );
  }

  copyTemplate(ogTemplate, results): void {
    //console.log(ogTemplate);
    this.getSingleTemplate(ogTemplate.id).subscribe(
      res => {
        console.log(res);
        let obj = {
          name : results.newName,
          fields: (JSON.stringify(res.Response.fields)),
          numfields: res.Response.numfields,
          description : results.newDesc
        }
        this.createTemplate(<Templates>obj);
      }
    )

  }







}
